import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'app/shared/shared.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { BankTransactionRoutingModule } from './bank-transaction-routing.module';
import { BankTransactionDashboardComponent } from './bank-transaction-dashboard/bank-transaction-dashboard.component';

@NgModule({
  imports: [
    CommonModule,
    BankTransactionRoutingModule,
    NgxPaginationModule,
    SharedModule,
    ReactiveFormsModule
  ],
  declarations: [
    BankTransactionDashboardComponent
  ],
  entryComponents: []
})
export class BankTransactionModule { }
